module.exports = __webpack_public_path__ + "static/img/产品界面图_05@2x.bb74c53b.png";